import { createSlice } from "@reduxjs/toolkit";

export interface State {
  payload: boolean;
}

const slice = createSlice({
  name: "isLayoutTall",
  initialState: { payload: false },
  reducers: {
    isLayoutTall: (state, { payload }) => {
      state.payload = payload;
    }
  }
});

export const { isLayoutTall } = slice.actions;
export default slice.reducer;
